module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"Privacy Policy","page.back":"กลับสู่หน้าหลัก"}}')
  delete Component.options._Ctor
}
